import { render, staticRenderFns } from "./RepairRegistrationList.vue?vue&type=template&id=7399a13a&scoped=true"
import script from "./RepairRegistrationList.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399a13a",
  null
  
)

export default component.exports